import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPaymentMethod } from "../../models/PaymentMethod";

interface IUserProfileState {
  data: IPaymentMethod[];
  defaultPaymentMethod: IPaymentMethod | null;
}

const initialState: IUserProfileState = {
  data: [],
  defaultPaymentMethod: null,
};

const userPaymentMethodsSlice = createSlice({
  name: "userPaymentMethods",
  initialState,
  reducers: {
    setPaymentMethods: (state, action: PayloadAction<IPaymentMethod[]>) => {
      state.data = action.payload;
    },
    getDefaultPaymentMethod: (state) => {
      if (state.data.length > 0) {
        const result = state.data.find((el) => el.isDefault);
        state.defaultPaymentMethod = result || null;
      } else {
        state.defaultPaymentMethod = null;
      }
    },
    setPaymentMethodsToInitial: (state) => {
      state.data = [];
      state.defaultPaymentMethod = null;
    },
  },
});

export const { setPaymentMethods, getDefaultPaymentMethod, setPaymentMethodsToInitial } =
  userPaymentMethodsSlice.actions;

export default userPaymentMethodsSlice.reducer;
